require('./helpers/bundle-manifest').register(JSON.parse("{\"arINw\":\"index.js\",\"dSdCs\":\"sw.js\",\"gkXQW\":\"index.css\"}"));